import axios from 'axios';
import {jwtDecode} from 'jwt-decode'; // Fix incorrect import
import { toast } from 'react-toastify'; // Example for displaying popups/toasts
import { useNavigate } from 'react-router-dom'; // Use this for redirecting

const axiosInstance = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL || '/api', // Replace with your API base URL
    headers: {
        'Content-Type': 'application/json',
    },
});

export const axiosUploadInstance = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL || '/api', // Replace with your API base URL
});

export const chatAxiosInstance = axios.create({
    baseURL: 'https://x5sqqbfe70.execute-api.us-east-1.amazonaws.com', // Replace with your API base URL
    headers: {
        'Content-Type': 'application/json',
    },
});

// Add an interceptor to include the token in requests
axiosInstance.interceptors.request.use((config) => {
    const token = localStorage.getItem('token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

// Add an interceptor to include the token in requests
axiosUploadInstance.interceptors.request.use((config) => {
    const token = localStorage.getItem('token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});


// Add a response interceptor to handle errors globally
axiosInstance.interceptors.response.use(
    (response) => response, // Pass through successful responses
    (error) => {
        // Check if error.response exists
        if (error.response) {
            const status = error.response.status;
            const message =
                error.response.data?.message ||
                `API call failed with status ${status}`;
            
            // Handle 403 Unauthorized
            if (status === 403) {
                toast.error("Session expired. Redirecting to login..."); // Show popup/toast
                setTimeout(() => {
                    localStorage.removeItem('token'); // Remove token
                    window.location.href = '/login'; // Redirect to login
                }, 3000); // Wait for 3 seconds before redirecting
            } else {
                // Handle other error statuses
                toast.error(message); // Show a popup or toast for other errors
            }
        } else {
            // Handle network or other unknown errors
            toast.error('Network error or server not reachable.');
        }
        return Promise.reject(error); // Reject the error for further handling
    }
);

// Decode roles from JWT
export const getUserRoles = () => {
    const token = localStorage.getItem('token');
    if (token) {
        const decoded = jwtDecode(token);
        return decoded.roles.map((role) => role.name); // Assuming role structure includes `name`
    }
    return [];
};

export const getUser = () => {
    const token = localStorage.getItem('token');
    if (token) {
        const decoded = jwtDecode(token);
        return decoded;
    }
    return null;
};


export default axiosInstance;
